export enum QueryApiCacheKeys {
  CARE_RESOURCES = "CARE_RESOURCES",
  COMPANY_MEMBERS = "COMPANY_MEMBERS",
  COMPANY_BENEFITS = "COMPANY_BENEFITS",
  COMPANY_BENEFIT_CONFIGURATIONS = "COMPANY_BENEFIT_CONFIGURATIONS",
  COMPANY_BENEFIT_ENROLLMENTS = "COMPANY_BENEFIT_ENROLLMENTS",
  COMPANY_MEMBER_CENSUS_UPLOAD_AUDIT_LOGS = "COMPANY_MEMBER_CENSUS_UPLOAD_AUDIT_LOGS",
  DEPENDENT_COMPANY_BENEFIT_ENROLLMENTS = "DEPENDENT_COMPANY_BENEFIT_ENROLLMENTS",
  EMPLOYEES_NOT_FOUND_IN_HRIS = "EMPLOYEES_NOT_FOUND_IN_HRIS",
  EMPLOYEES_WE_CANNOT_ADD_FROM_HRIS = "EMPLOYEES_WE_CANNOT_ADD_FROM_HRIS",
  ICHRA_CONTRIBUTION_CLASSES = "ICHRA_CONTRIBUTION_CLASSES",
  INDIVIDUAL_PLAN_SUMMARY = "INDIVIDUAL_PLAN_SUMMARY",
  INDIVIDUAL_PLAN_PERSONALIZED_SUMMARY = "INDIVIDUAL_PLAN_PERSONALIZED_SUMMARY",
  INSURANCE_NETWORKS = "INSURANCE_NETWORKS",
  INTERCOM_JWT = "INTERCOM_JWT",
  LAB_FACILITY = "LAB_FACILITY",
  LEGAL_DEPENDENTS = "LEGAL_DEPENDENTS",
  MARKETPLACE_PLANS = "MARKETPLACE_PLANS",
  OCC_HEALTH_PRODUCT_USAGE_FOR_CURRENT_TERM = "OCC_HEALTH_PRODUCT_USAGE_FOR_CURRENT_TERM",
  OPEN_ENROLLMENT_ELIGIBLE_EMPLOYEE_NOTIFICATION_LOGS = "OPEN_ENROLLMENT_ELIGIBLE_EMPLOYEE_NOTIFICATION_LOGS",
  PAYMENT_ACCOUNTS = "PAYMENT_ACCOUNTS",
  PLAN_YEAR_ELIGIBILITY_POLICY = "PLAN_YEAR_ELIGIBILITY_POLICY",
  QUALIFYING_LIFE_EVENTS = "QUALIFYING_LIFE_EVENTS",
  REIMBURSEMENT_REQUESTS = "REIMBURSEMENT_REQUESTS",
  HEALTH_WALLET_ACCOUNTS = "HEALTH_WALLET_ACCOUNTS",
  SPECIALTIES = "SPECIALTIES",
  PAYROLL_DEDUCTION_STATEMENTS = "PAYROLL_DEDUCTION_STATEMENTS",
  ENROLLMENT_AGENCIES = "ENROLLMENT_AGENCIES",
  COMPANY_BENEFIT_INVOICES = "COMPANY_BENEFIT_INVOICES",
  COVERED_MEDICATIONS = "COVERED_MEDICATIONS",
  BILLING_INVOICES = "BILLING_INVOICES",
  AI_CONVERSATIONS = "AI_CONVERSATIONS",
  COMPANY_SETTINGS = "COMPANY_SETTINGS",
  ACA_POLICY = "ACA_POLICY",
  VITABLE_ADMIN_EMPLOYERS = "VITABLE_ADMIN_EMPLOYERS"
}
